import { observer } from 'mobx-react-lite'
import TemplateTitle from '../../../template/title/TemplateTitle'
import React, { useState } from 'react'
import i from '../../../../translations/i'
import { ProductTable } from '../../../../components/product_table/ProductTable'
import { ProductTableController, WITHOUT_CATEGORY } from '../../../../components/product_table/product_table.controller'

// Товары, не привязанные ни к одной категории
const ProductsWithoutCategory = observer(() => {
    const [table] = useState(() => new ProductTableController({ categoryId: WITHOUT_CATEGORY, syncUrl: true }))

    const breadcrumb = [
        { link: '/shop', value: i.t('crumb:shop') },
        { link: null, value: i.t('crumb:without') }
    ]

    return (
        <>
            <TemplateTitle
                title={i.t('crumb:without')}
                breadcrumb={breadcrumb}
            />

            <ProductTable table={table} />
        </>
    )
})

export default ProductsWithoutCategory
